import { cn } from 'component-library/utils';

export const NewTabLink = ({ label, url, className }: { label: string; url: string; className?: string }) => {
  return (
    <a
      className={cn('text-primary-100 hover:text-primary-light underline', className)}
      href={url}
      target='_blank'
      rel='noopener noreferrer'
    >
      {label}
    </a>
  );
};
